import React from 'react';
import { Link } from 'react-router-dom';
import { QrCode, ArrowLeft } from 'lucide-react';

const Confidentialite = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900">
            <ArrowLeft className="h-4 w-4" />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center">
            <QrCode className="h-7 w-7 text-white" />
          </div>
          <h1 className="font-heading text-3xl font-bold text-gray-900">Politique de Confidentialité</h1>
        </div>

        <div className="bg-white rounded-2xl shadow-soft p-8 space-y-8">
          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
            <p className="text-gray-600">
              La SARL DEALRUN (SIRET : 895 350 783 00018), éditrice de ZOTMENU, s'engage à protéger 
              la vie privée des utilisateurs de son service. Cette politique de confidentialité explique 
              comment nous collectons, utilisons et protégeons vos données personnelles conformément au 
              Règlement Général sur la Protection des Données (RGPD).
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">2. Responsable du traitement</h2>
            <div className="text-gray-600 space-y-2">
              <p><strong>SARL DEALRUN</strong></p>
              <p>SIRET : 895 350 783 00018</p>
              <p>Email : <a href="mailto:contact@dealrun.re" className="text-orange-500 hover:underline">contact@dealrun.re</a></p>
              <p>Téléphone : <a href="tel:0693463628" className="text-orange-500 hover:underline">06 93 46 36 28</a></p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">3. Données collectées</h2>
            <div className="text-gray-600 space-y-4">
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">Données d'identification :</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Adresse email</li>
                  <li>Mot de passe (chiffré)</li>
                  <li>Nom du restaurant</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">Données de contenu :</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Menus, catégories et plats créés</li>
                  <li>Images téléchargées</li>
                  <li>Descriptions et prix</li>
                  <li>Promotions configurées</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">Données d'utilisation :</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Statistiques de consultation des menus</li>
                  <li>Logs de connexion</li>
                  <li>Préférences de paramétrage</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">4. Finalités du traitement</h2>
            <div className="text-gray-600">
              <p>Vos données sont collectées pour :</p>
              <ul className="list-disc list-inside space-y-1 ml-4 mt-2">
                <li>Fournir et gérer le service ZOTMENU</li>
                <li>Permettre l'authentification et la sécurité du compte</li>
                <li>Afficher votre menu aux clients via QR Code</li>
                <li>Générer des statistiques d'utilisation</li>
                <li>Améliorer le service grâce aux fonctionnalités IA</li>
                <li>Vous contacter pour le support et les notifications importantes</li>
                <li>Traiter les paiements d'abonnement</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">5. Base légale du traitement</h2>
            <div className="text-gray-600">
              <p>Le traitement de vos données repose sur :</p>
              <ul className="list-disc list-inside space-y-1 ml-4 mt-2">
                <li><strong>L'exécution du contrat</strong> : fourniture du service souscrit</li>
                <li><strong>Le consentement</strong> : pour les cookies non essentiels et communications marketing</li>
                <li><strong>L'intérêt légitime</strong> : amélioration du service et sécurité</li>
                <li><strong>L'obligation légale</strong> : conservation des données de facturation</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">6. Durée de conservation</h2>
            <div className="text-gray-600">
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>Données du compte</strong> : conservées pendant la durée de l'abonnement + 3 ans</li>
                <li><strong>Données de facturation</strong> : 10 ans (obligation légale)</li>
                <li><strong>Données d'utilisation</strong> : 12 mois glissants</li>
                <li><strong>Cookies</strong> : 13 mois maximum</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">7. Partage des données</h2>
            <div className="text-gray-600 space-y-2">
              <p>Vos données peuvent être partagées avec :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>Stripe</strong> : traitement des paiements (certifié PCI-DSS)</li>
                <li><strong>Services d'hébergement</strong> : stockage sécurisé des données</li>
                <li><strong>Services d'IA</strong> : génération de contenu (données anonymisées)</li>
              </ul>
              <p className="mt-2">
                Nous ne vendons jamais vos données personnelles à des tiers.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">8. Sécurité des données</h2>
            <div className="text-gray-600">
              <p>Nous mettons en œuvre des mesures de sécurité appropriées :</p>
              <ul className="list-disc list-inside space-y-1 ml-4 mt-2">
                <li>Chiffrement des mots de passe (bcrypt)</li>
                <li>Connexions sécurisées (HTTPS/TLS)</li>
                <li>Authentification par token JWT</li>
                <li>Sauvegardes régulières</li>
                <li>Accès restreint aux données</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">9. Vos droits</h2>
            <div className="text-gray-600 space-y-2">
              <p>Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>Droit d'accès</strong> : obtenir une copie de vos données</li>
                <li><strong>Droit de rectification</strong> : corriger vos données inexactes</li>
                <li><strong>Droit à l'effacement</strong> : demander la suppression de vos données</li>
                <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format standard</li>
                <li><strong>Droit d'opposition</strong> : vous opposer à certains traitements</li>
                <li><strong>Droit de limitation</strong> : restreindre le traitement de vos données</li>
              </ul>
              <p className="mt-4">
                Pour exercer ces droits, contactez-nous à : 
                <a href="mailto:contact@dealrun.re" className="text-orange-500 hover:underline ml-1">contact@dealrun.re</a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">10. Cookies</h2>
            <div className="text-gray-600 space-y-2">
              <p>ZOTMENU utilise des cookies pour :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>Cookies essentiels</strong> : authentification, sécurité (obligatoires)</li>
                <li><strong>Cookies analytiques</strong> : mesure d'audience (avec consentement)</li>
              </ul>
              <p className="mt-2">
                Vous pouvez gérer vos préférences de cookies dans les paramètres de votre navigateur.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">11. Transfert de données</h2>
            <p className="text-gray-600">
              Vos données peuvent être transférées vers des serveurs situés hors de l'Union Européenne. 
              Dans ce cas, nous nous assurons que des garanties appropriées sont en place 
              (clauses contractuelles types, certification Privacy Shield, etc.).
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">12. Réclamation</h2>
            <p className="text-gray-600">
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation 
              auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) : 
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:underline ml-1">www.cnil.fr</a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">13. Modifications</h2>
            <p className="text-gray-600">
              Cette politique de confidentialité peut être mise à jour. En cas de modification substantielle, 
              nous vous en informerons par email ou via une notification sur la plateforme.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">14. Contact</h2>
            <div className="text-gray-600">
              <p>Pour toute question relative à cette politique :</p>
              <p className="mt-2">
                <strong>Email :</strong> <a href="mailto:contact@dealrun.re" className="text-orange-500 hover:underline">contact@dealrun.re</a><br />
                <strong>Téléphone :</strong> <a href="tel:0693463628" className="text-orange-500 hover:underline">06 93 46 36 28</a>
              </p>
            </div>
          </section>
        </div>

        <p className="text-center text-gray-500 text-sm mt-8">
          Dernière mise à jour : Janvier 2025
        </p>
      </main>
    </div>
  );
};

export default Confidentialite;
